module.exports = "<div class=\"row office-license-container\">\n    <div class=\"col-md-3\">\n        <p>CSLB# 1255789</p>\n        <p>Joe Smith</span>\n    </div>\n    <div class=\"col-md-4\">\n        <p>2198 S. James Street</p>\n        <p>San Diego, CA 92126</p>\n    </div>\n    <div class=\"col-md-3 license-contact-info\">\n        <p>(855) 410-4700</p>\n        <p>office345@a1solarpower.com</p>\n    </div>\n    <div class=\"col-md-2\">\n\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/offices/licensure/viewLicensure.html
// module id = 476
// module chunks = 1